export const SESSION_GIT_RESULT_EVENT = "cord:session-git-result"

export interface SessionGitResultDetail {
  sessionId: string
  operation: "push" | "pull" | "sync" | "fetch" | "merge-base"
  ok: boolean
  error?: string | null
}

export function dispatchSessionGitResult(detail: SessionGitResultDetail): void {
  if (typeof window === "undefined") return
  window.dispatchEvent(
    new CustomEvent<SessionGitResultDetail>(SESSION_GIT_RESULT_EVENT, {
      detail,
    }),
  )
}
